export default __webpack_public_path__ + "static/media/06-onlinespellen.ac751bcf.png";